import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonSmall from '../../../sharable/components/ButtonSmall';
import styles from './ArticlesItemTags.module.scss';
import { changeArticlesAppliedFilterTags } from '../../reducers/loadArticlesSlice';
import { selectArticlesAppliedFilterTags } from '../../reducers/articlesSelectors';

interface IArticlesItemTagsProps {
  tags: string[];
}

const ArticlesItemTags = ({ tags = [] }: IArticlesItemTagsProps): JSX.Element => {
  const appliedFilterTags = useSelector(selectArticlesAppliedFilterTags);
  const [visibleTags, setVisibleTags] = useState([]);
  const tagsElementRef = useRef(null);
  const dispatch = useDispatch();
  const hiddenTagsCount = tags.length - visibleTags.length;

  const getTextLinesNumber = (element: HTMLElement) => {
    const style = getComputedStyle(element);

    return element.offsetHeight / parseInt(style.lineHeight, 10);
  };

  useEffect(() => {
    const visibleTagsAcc = [];
    tagsElementRef.current.style.visibility = 'hidden';

    for (const tag of tags) {
      const currHiddenTagsCount = tags.length - (visibleTagsAcc.length + 1);
      const moreTagsPlaceholder = `+${currHiddenTagsCount} More`;
      tagsElementRef.current.innerText = `${[...visibleTagsAcc, tag].join(', ')} ${
        currHiddenTagsCount > 0 ? moreTagsPlaceholder : ''
      }}`;

      if (getTextLinesNumber(tagsElementRef.current) > 1) {
        break;
      }

      visibleTagsAcc.push(tag);
    }

    tagsElementRef.current.innerText = '';
    tagsElementRef.current.style.visibility = 'visible';
    setVisibleTags(visibleTagsAcc);
  }, []);

  const onShowMoreClick = () => setVisibleTags(tags);

  const onArticleTagClick = (tag: string) => {
    if (appliedFilterTags.includes(tag)) {
      return;
    }

    dispatch(changeArticlesAppliedFilterTags([...appliedFilterTags, tag]));
  };

  return (
    <div className={styles.container}>
      <span ref={tagsElementRef} className={styles.articleTags}>
        {visibleTags.map((visibleTag, index) => (
          <Fragment key={index}>
            <a className={styles.articleTag} onClick={() => onArticleTagClick(visibleTag)}>
              {visibleTag}
            </a>
            {index !== visibleTags.length - 1 ? ', ' : ''}
          </Fragment>
        ))}
      </span>

      {!!hiddenTagsCount && (
        <ButtonSmall className={styles.showMore} variant="action" onClick={onShowMoreClick}>
          {`+${hiddenTagsCount} More`}
        </ButtonSmall>
      )}
    </div>
  );
};

export default ArticlesItemTags;
